import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiRaterPanelComponent } from './multi-rater-panel/multi-rater-panel.component';
import { AvatarPillComponent, UserAvatarPipe } from '@frontend/shared';



@NgModule({
  declarations: [
    MultiRaterPanelComponent
  ],
  imports: [
    CommonModule,
    AvatarPillComponent,
    UserAvatarPipe,
  ],
  exports: [
    MultiRaterPanelComponent
  ],
})
export class SurveyRatersModule { }
